import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from './slice';

const selectDomain = (state: RootState) =>
  state.dealerDailyCdpSyncSettingsComponentState || initialState;

export const selectDealerDailyCdpSyncSettings = createSelector(
  [selectDomain],
  dealerDailyCdpSyncSettingsComponentState =>
    dealerDailyCdpSyncSettingsComponentState.dealerDailyCdpSyncSettings,
);
